import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import 'react-toastify/dist/ReactToastify.css';
import {Link} from "react-router-dom";
import FormModel from "./form/FormModel";
import CommentMarcheLahalle from "./lahalle/commentmarche";
import CommentMarche from "./accueil/commentmarche";
import FaqPopUpLahalle from "./lahalle/faqPopup";
import CommentMarcheIncluvia from "./incluvia/commentmarche";

function ContactModal({
              textButton,
              small,
              linkPageContact,
              iframe,
              couleur,
              formModal,
              designBtn = true,
              iconMenu,
              page,
              faq = false
}) {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = (event) => {
        event.preventDefault();
        setShow(true)
    };
    const lienBookingLahalle = "https://outlook.office.com/book/HotlineTalentsHandicapLaHalle@talents-handicap.com/?ismsaljsauthenabled";
    const lienBookingBourso = "https://outlook.office365.com/owa/calendar/HotlineTalentsHandicap@talents-handicap.com/bookings/";
    const lienBookingIncluvia = "https://outlook.office.com/book/HotlineHandicapIncluvia@talents-handicap.com/";


    const lienIframe =
        page === "lahalle"
            ? lienBookingLahalle
            : page === "incluvia"
                ? lienBookingIncluvia
                : lienBookingBourso;
    const size = faq ? 'xl' : (iframe ? 'xl' : 'lg');
    return (
            <>
                {linkPageContact ? (
                    <>
                        {designBtn ? (
                            <Link
                                to="/contact"
                                className={`theme-btn btn-style-one mt-3 ${small}`}
                            >{textButton}
                            </Link>
                        ): (
                            <Link
                                to="/contact"
                            >
                                {iconMenu ? (
                                     <><img src={iconMenu} alt={textButton} width="20" /> {textButton}</>
                                ) : (
                                    {textButton}
                                )}
                            </Link>
                        )}
                    </>
                ): (
                    <>
                        {designBtn ? (
                            <>
                                {couleur ? (
                                    <Link to="#" className={`theme-btn btn-style-six mt-3 ${small}`} onClick={handleShow}>
                                        {textButton}
                                    </Link>
                                ): (
                                    <Link to="#" className={`theme-btn btn-style-one mt-3 ${small}`} onClick={handleShow}>
                                    {textButton}
                                    </Link>
                                )}
                            </>
                        ): (
                            <Link to="#" onClick={handleShow}>
                                {iconMenu ? (
                                    <><img src={iconMenu} alt={textButton} width="20" /> {textButton}</>
                                ) : (
                                    {textButton}
                                )}
                            </Link>
                        )}
                    </>
                    )
                }

                <Modal show={show} onHide={handleClose} backdrop={true} centered size={size}>
                    <Modal.Header closeButton>
                        <Modal.Title></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {iframe ? (
                            <div style={{height: '750px'}}>
                                <iframe
                                    src={lienIframe}
                                    title="Réserver un créneau"
                                    width='100%'
                                    height='100%' scrolling='yes' style={{border: 0}}>

                                </iframe>

                            </div>
                        ) : (

                            <>
                            {formModal ? (
                                <>
                                    <h2 className="libre-title mb-5">{textButton}</h2>
                                    <FormModel sujet={textButton}/>
                                </>
                            ): (
                                <>
                                    {page === "lahalle" ? (
                                        <>
                                        {faq ? (
                                                <FaqPopUpLahalle page={page} />
                                            ): (
                                                <CommentMarcheLahalle />
                                            )}
                                        </>
                                    ):  page === "incluvia" ? (
                                        <>
                                            {faq ? (
                                                <FaqPopUpLahalle page={page} />
                                            ): (
                                                <CommentMarcheIncluvia/>
                                            )}
                                        </>

                                    ):  (
                                        <CommentMarche />
                                    )}
                                </>

                            )}

                            </>
                        )}
                    </Modal.Body>
                </Modal>
            </>
    );
}

export default ContactModal;